/**
 * Benefit Category Enum
 *
 * Defines the different categories of benefits that can be associated with an investment.
 * More granular than the simple Q/N (Quantitative/Non-Quantitative) classification.
 */
export const BenefitCategoryLabel = {
    cost_reduction: 'Cost Reduction',
    revenue_increase: 'Revenue Increase',
    fte_replacement: 'FTE Replacement',
    efficiency_gain: 'Efficiency Gain',
    cost_avoidance: 'Cost Avoidance',
    qualitative: 'Qualitative/Strategic',
};
export const BenefitCategoryDescription = {
    cost_reduction: 'Reduces existing costs such as hosting, licenses, or services',
    revenue_increase: 'Increases annual recurring revenue (ARR) by dollar amount or percentage',
    fte_replacement: 'Reduces headcount or replaces FTEs',
    efficiency_gain: 'Saves time on existing processes (hours saved × rate)',
    cost_avoidance: 'Avoids future costs that would otherwise be incurred',
    qualitative: 'Strategic benefits like market parity, client retention, employee satisfaction',
};
export const BENEFIT_CATEGORIES = [
    'cost_reduction',
    'revenue_increase',
    'fte_replacement',
    'efficiency_gain',
    'cost_avoidance',
    'qualitative',
];
/**
 * Whether this benefit category is quantifiable (has a dollar value)
 */
export const BenefitCategoryIsQuantifiable = {
    cost_reduction: true,
    revenue_increase: true,
    fte_replacement: true,
    efficiency_gain: true,
    cost_avoidance: true,
    qualitative: false,
};
//# sourceMappingURL=benefit-category.enum.js.map